import React, { useState, useEffect } from "react";
import { getAllFolder } from "../api/folderapi";
import { useNavigate } from "react-router-dom";
import { filedata } from "../data/filedata";
import FileView from "../Component/FIleView";
import { Tuning2 } from "@solar-icons/react";
import { FaList, FaRegStar } from "react-icons/fa";
import { IoGridOutline } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import useFiles from "../context/FileContext";
import { FaLock } from "react-icons/fa";
import { getFileIcon } from "../utils/Icon";
import { toast } from "react-hot-toast";
import { HiDotsVertical } from "react-icons/hi";
import ShareView from "../Component/ShareView";
import FileInformation from "../Component/FileInformation";
import MoveModal from "../Component/MoveModel";
import DeleteView from "../Component/DeleteView";
import { useRef } from "react";
import { deleteFolder } from "../api/folderapi";
import { useContext, useMemo } from "react";
import { value } from "../data/item";
import MenuComponent from "../Component/MenuComponent";

const Starred = () => {
  const { files, setFiles, viewType, setViewType, search } = useFiles();
  const [items, setItems] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const menuRef = useRef(null);
  const [menuOpenId, setMenuOpenId] = useState(false);
  const [copiedFile, setCopiedFile] = useState(null);
  const [infoFile, setInfoFile] = useState(null);
  const [selectedForMove, setSelectedForMove] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [menuOpen, setMenuOpen] = useState(null);
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [infoModel, setInfoModel] = useState(false);

  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const fetchFolders = async () => {
    try {
      setIsLoading(true);
      const res = await getAllFolder();
      setDatas(res.data);
      const rootFolders = res.data.filter((d) => d.type === "folder");
      setFiles(rootFolders);
    } catch (error) {
      console.error("Error fetching folders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = (fileUrl) => {
    if (!fileUrl) {
      alert("Download URL is missing!");
      return;
    }

    const handleDeleteConfirm = async (_id, name) => {
      try {
        if (selectedFolderForDelete) {
          const res = await deleteFolder(selectedFolderForDelete._id);

          toast.success(res.message);
          fetchFolders();
          setIsPopupOpen(false);
          setSelectedFolderForDelete(null);
          setMenuOpen(null);
        }
      } catch (error) {
        toast.error("Error deleting folder");
      }
    };

    const handleDeleteCancel = () => {
      setIsPopupOpen(false);
      setSelectedFolderForDelete(null);
    };

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDeleteConfirm = async (_id, name) => {
    try {
      if (selectedFolderForDelete) {
        const res = await deleteFolder(selectedFolderForDelete._id);

        toast.success(res.message);
        fetchFolders();
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
      }
    } catch (error) {
      toast.error("Error deleting folder");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  const displayedFiles = useMemo(() => {
    let filtered = currentFolder ? [...currentFolder.items] : [...files];

    if (search) {
      filtered = filtered.filter((file) =>
        file.name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    return filtered;
  }, [files, currentFolder, search]);

  const handleFolderClick = (folder) => {
    if (folder.isLocked) {
      const enteredPassword = prompt(
        "This folder is locked. Enter the password:"
      );
      if (enteredPassword !== folder.password) {
        alert("Incorrect password! Access denied.");
        return;
      }
    }

    if (folder.isDirectory) {
      setBreadcrumb((prev) => [...prev, folder]);
      setCurrentFolder(folder);
    } else {
      console.log("File clicked (no drill‐down):", folder.name);
    }
  };

  useEffect(() => {
    getAllFolder()
      .then((res) => {
        const datas = res.data
          .filter(
            (item) =>
              item.mimeType &&
              item.mimeType.toLowerCase().includes("application") &&
              item.size
          )
          .map((item) => ({
            ...item,
            sizeMB: (Number(item.size) / (1024 * 1024)).toFixed(2),
          }));

        setDatas(datas);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="mt-[10%] md:mt-[4%]">
      <div className=" flex justify-between mt-10 md:mt-5">
        <h4 className="text-secondary font-semibold text-xl">Starred</h4>

        <div className="flex justify-end gap-3 ">
          <div className="hidden md:w-10 h-10 border border-gray-300 rounded-md md:flex items-center justify-center hover:bg-gray-100 cursor-pointer">
            <Tuning2 onClick={() => setShowFilter(!showFilter)} />
          </div>

          <div className="flex border border-gray-300  rounded-md overflow-hidden w-fit h-10">
            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "list" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("list");
                setIsMenuOpen(false);
              }}
            >
              <FaList />
            </button>

            <button
              className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                viewType === "grid" ? "bg-four text-black" : "text-secondary "
              }`}
              onClick={() => {
                setViewType("grid");
                setIsMenuOpen(false);
              }}
            >
              <IoGridOutline />
            </button>
          </div>

          <button
            className="hidden md:w-[150px] h-10 md:flex items-center justify-center gap-2 border border-gray-300 bg-four text-secondary font-medium text-sm rounded-md hover:opacity-90 transition"
            onClick={() => setShowAll(!showAll)}
          >
            <span>View all</span>
            <IoIosArrowUp
              fontSize={20}
              className={`transition-transform duration-300 ${
                showAll ? "rotate-180" : ""
              }`}
            />
          </button>
        </div>
      </div>

      {viewType === "grid" ? (
          <div className={`grid gap-5  mt-5
    grid-cols-2 
    ${showShareModal || showInfoModal || showFilter 
      ? "md:grid-cols-4 w-[80%]" 
      : "sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full  "
    }`}>
                   {datas
                     .filter((item) => item.type === "file")
                     .slice(0, showAll ? datas.length : 5)
                     .map((file, i) => {
                       const icon = getFileIcon(file.name, file.url);
       
                       return (
                         <div
                           key={file._id}
                           className="relative flex flex-col items-center  shadow-md  hover:shadow-lg transition duration-300 bg-white p-1 border border-gray-300 rounded-md"
                         >
                          
                           <div className="absolute top-2 right-2 flex space-x-2 text-black z-10">
                             <button>
                               <FaRegStar />
                             </button>
                             <button
                               onClick={() =>
                                 setMenuOpenId(
                                   menuOpenId === file._id ? null : file._id
                                 )
                               }
                             >
                               <HiDotsVertical fontSize={20} />
                             </button>
       
                            
                             {menuOpenId === file._id && (
                               <MenuComponent
                                 file={file}
                                 setMenuOpenId={setMenuOpenId}
                                 renameValue={renameValue}
                                 setRenameValue={setRenameValue}
                                 setRenamingId={setRenamingId}
                                 showShareModal={showShareModal}
                                 setShowShareModal={setShowShareModal}
                                 infoModel={infoModel}
                                 setInfoModel={setInfoModel}
                                 showInfoModal={showInfoModal}
                                 setShowInfoModal={setShowInfoModal}
                                 setInfoFile={setInfoFile}
                               />
                             )}
                           </div>
       
                          
                           <div
                             className=" flex items-center justify-center cursor-pointer rounded-lg bg-gray-50 h-32"
                             onClick={() => handleItemClick(file)}
                           >
                             {typeof icon === "string" ? (
                               <img
                                 src={icon}
                                 alt={file.name}
                                 className="w-full h-full object-cover object-center"
                               />
                             ) : (
                               icon
                             )}
                           </div>
       
                          
                           <span className=" text-sm text-center font-medium text-gray-700 truncate w-full">
                             {file.name.slice(0, 10)}
                           </span>
                         </div>
                       );
                     })}
                 </div>
      ) : (
        <div className="w-full overflow-x-auto mt-5">
                    <table
                      className="min-w-[700px] w-full table-auto  text-sm text-left"
                      ref={menuRef}
                    >
                      <thead className=" text-xs md:text-sm">
                        <tr className="text-secondary font-semibold">
                          {["Name", "Created At", "Main Access", "Size", "More"].map(
                            (col, i) => (
                              <th key={i} className="p-2 md:p-4 whitespace-nowrap text-secondary">
                                {col}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
        
                     
                      <tbody>
                        {datas
                          .filter((file) => !file.trashed)
                          .filter((item) => item.type === "file")
        
                          .slice(0, showAll ? datas.length : 5)
                          .map((file, index) => {
                            const fileId = file.id || file._id;
        
                            return (
                              <tr key={fileId} className="hover:bg-third">
                                <td className="p-2 md:p-4 text-secondary">
                                  <div className="flex items-center gap-4">
                                    <div className="relative w-10 h-10 md:w-8 md:h-8">
                                      {file.isLocked && (
                                        <FaLock
                                          className="absolute top-0 left-0 text-red-500 z-10"
                                          fontSize={14}
                                        />
                                      )}
                                      <img
                                        src={getFileIcon(file.name, file.url)}
                                        alt={file.name}
                                        onClick={() => handleItemClick(file)}
                                        className={`w-full h-full rounded-md object-cover transition-all duration-300 ${
                                          file.isLocked && !file.isDirectory
                                            ? "blur-md opacity-50 cursor-not-allowed"
                                            : ""
                                        }`}
                                      />
                                    </div>
                                    <span
                                      className="cursor-pointer font-medium text-secondary text-sm truncate max-w-[150px]"
                                      onClick={() =>
                                        !file.isLocked &&
                                        (file.isDirectory
                                          ? handleFolderClick(file)
                                          : setSelectedFile(file))
                                      }
                                    >
                                      {file.name.slice(0, 20)}
                                    </span>
                                  </div>
                                </td>
        
                                
                                <td className="p-2 md:p-4 text-secondary">
                                  {file.updatedAt?.slice(0, 10)}
                                </td>
        
                               
                                <td className="p-2 md:p-4 text-secondary">
                                  <div className="flex items-center gap-2">
                                    {value[index]?.profile && (
                                      <img
                                        src={value[index].profile}
                                        alt="profile"
                                        className="w-5 h-5 rounded-full"
                                      />
                                    )}
                                  
                                    {value[index]?.avatar && (
                                      <img
                                        src={value[index].avatar}
                                        alt="avatar"
                                        className="w-5 h-5 rounded-full"
                                      />
                                    )}
                                  </div>
                                
                                </td>
        
                              
                                <td className="p-2 md:p-4 text-secondary">
                                  <div className="flex items-center gap-2">
                                    {value[index]?.avatar1 && (
                                      <img
                                        src={value[index].avatar1}
                                        alt="avatar"
                                        className="w-5 h-5 rounded-full"
                                      />
                                    )}
                                    <span>{value[index]?.size || "--"}</span>
                                  </div>
                                  
                                </td>
        
                              
                                <td className="p-2 md:p-4 text-secondary">
                                  <div
                                    className="inline-flex items-center justify-center text-sm text-secondary font-medium cursor-pointer"
                                    onClick={() =>
                                      setMenuOpenId(
                                        menuOpenId === fileId ? null : fileId
                                      )
                                    }
                                  >
                                    <HiDotsVertical fontSize={20} />
                                  </div>
        
                                  {menuOpenId === fileId && (
                                    <MenuComponent
                                      file={file}
                                      setMenuOpenId={setMenuOpenId}
                                      renameValue={renameValue}
                                      setRenameValue={setRenameValue}
                                      setRenamingId={setRenamingId}
                                      showShareModal={showShareModal}
                                      infoModel={infoModel}
                                      setInfoModel={setInfoModel}
                                      setShowShareModal={setShowShareModal}
                                      showInfoModal={showInfoModal}
                                      setShowInfoModal={setShowInfoModal}
                                      setInfoFile={setInfoFile}
                                    />
                                  )}
        
                                  {showShareModal && (
                                    <ShareView
                                      setIsOpen={setShowShareModal}
                                      handleShare={() => {
                                        toast.success("File shared successfully!");
                                        setShowShareModal(false);
                                      }}
                                    />
                                  )}
        
                                  <FileInformation
                                    showInfoModal={showInfoModal}
                                    infoFile={infoFile}
                                    onClose={() => setShowInfoModal(false)}
                                  />
        
                                  {showMoveModal && selectedForMove && (
                                    <MoveModal
                                      file={selectedForMove}
                                      folders={files.filter(
                                        (f) => f.isDirectory && !f.trashed
                                      )}
                                      onClose={() => setShowMoveModal(false)}
                                      onMove={(destinationId) => {
                                        setFiles((prev) =>
                                          prev.map((f) =>
                                            f._id === selectedForMove._id
                                              ? { ...f, parentId: destinationId }
                                              : f
                                          )
                                        );
                                        setShowMoveModal(false);
                                        toast.success("Moved successfully");
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
        
                       
                        {isPopupOpen && (
                          <tr>
                            <td colSpan={5}>
                              <DeleteView
                                handleDeleteCancel={handleDeleteCancel}
                                handleDeleteConfirm={handleDeleteConfirm}
                              />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
      )}

      <div>
        {selectedFile && (
          <FileView
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            handleDownload={handleDownload}
          />
        )}
      </div>
    </div>
  );
};

export default Starred;
